<template>
  <div class="empty-content flex-container flex-column flex-horiz-center">
      <img class="pic" :src="img" alt="">
      <span class="text">{{ text }}</span>
    </div>
</template>
<script>
import DefaultEmptyImg from '@/assets/image/pic_empty.png'
export default {
  name: 'EmptyContent',
  props: {
    img: {
      type: String,
      default: DefaultEmptyImg
    },
    text: {
      type: String,
      default: '没有相关结果'
    }
  },
}
</script>

<style lang="less" scoped>
.empty-content{
  padding: 72px 0;
  .pic{
    width: 200px;
    height: 200px;
  }
  .text{
    padding: 8px 0;
    color: @theme-grey-3;
  }
}
</style>
